module.exports = {
  en: {
    Device: 'Device',
    VideoView3sec: '3s video plays',
    ad: 'Ad',
    adAccount: 'Ad account',
    adAccountName: 'Ad account',
    adId: 'Ad ID',
    adName: 'Ad name',
    adSet: 'Ad set',
    adSetId: 'Ad set ID',
    adSetName: 'Ad set name',
    adSetStatus: 'Ad set status',
    adSettings: 'Ad settings',
    adSpent: 'Ad spend',
    adStatus: 'Ad status',
    addBudget: 'Add budget',
    add_cart_count: 'Add Cart Count',
    add_cart_rate: 'Add Cart Rate',
    add_to_cart: 'Add to cart',
    add_to_cart_1D: 'Add to cart (1D)',
    add_to_cart_7D: 'Add to cart (7D)',
    adeffect_ad_details: 'Adeffect Ad Details',
    adeffect_addetails: 'Adeffect Addetails',
    age: 'Age',
    all: 'No grouping',
    allConversions: 'All conversions(Google)',
    amountSpentPercentage: 'Amount spent percentage',
    appPlatforms: 'App Device',
    app_discount_amount: 'App discount amount',
    app_install: 'App install',
    app_install_1D: 'App install (1D)',
    app_install_7D: 'App install (7D)',
    assistedConversions: 'Assisted Conversions',
    assistedValue: 'Assisted Value',
    autoTime: 'Auto time breakdown',
    averageSessionDuration: 'Session duration',
    bidCap: 'Bid cap',
    bidStrategies: 'Bid strategy',
    bidStrategy: 'Bid strategy',
    billingHistory: 'Billing history',
    billing_name: 'Billing name',
    bounceRate: 'Bounce rate',
    bouncedUsers: 'Bounced users',
    bounces: 'Bounces',
    budget: 'Budget',
    buyers_count: 'Buyers Count',
    campaign: 'Campaign',
    campaignId: 'Campaign ID',
    campaignName: 'Campaign name',
    campaignStatus: 'Campaign status',
    carts_action: 'Carts Action',
    carts_count_per_category: 'Carts Count Per Category',
    category_name: 'Category Name',
    category_no: 'Category No',
    channel: 'Channel',
    channelAdAccountId: 'Ad account ID',
    channelKeywordId: 'Keyword ID',
    channelSubType: 'Channel type',
    channelSubType_app_campaign: 'App',
    channelSubType_app_campaign_for_engagement: 'App Engagement',
    channelSubType_app_campaign_for_pre_registration: 'App Pre-registration',
    channelSubType_brand_search: 'Brand Search',
    channelSubType_daum_shopping: 'Daum Shopping',
    channelSubType_display: 'Display',
    channelSubType_display_express: 'Express Display',
    channelSubType_display_gmail_ad: 'Gmail Display',
    channelSubType_display_mobile_app: 'Mobile App Display',
    channelSubType_display_smart_campaign: 'Smart Display',
    channelSubType_local_campaign: 'Local',
    channelSubType_place: 'Place',
    channelSubType_search: 'Search',
    channelSubType_search_express: 'Express Search',
    channelSubType_search_mobile_app: 'Mobile App Search',
    channelSubType_shopping: 'Shopping',
    channelSubType_shopping_comparison_listing_ads: 'Comparison Shopping',
    channelSubType_shopping_smart_ads: 'Smart Shopping',
    channelSubType_smart_campaign: 'Smart',
    channelSubType_sponsored_board: 'Sponsored Board',
    channelSubType_talk_biz_board: 'Biz Board',
    channelSubType_talk_channel: 'Channel',
    channelSubType_unknown: 'Unknown',
    channelSubType_unspecified: 'Unspecified',
    channelSubType_video: 'Video',
    channelSubType_video_action: 'Action Video',
    channelSubType_video_non_skippable: 'Non-skippable Video',
    channelSubType_video_outstream: 'Outstream Video',
    channelSubType_video_sequence: 'Sequence Video',
    channelSubType_web_site: 'Website',
    clicks: 'Link clicks',
    clicksAll: 'Clicks (all)',
    clicksLead: 'LinkedIn Leads',
    colorClustering: 'Color clustering',
    comments: 'Comments',
    completed_registration: 'Completed registration',
    completed_registration_1D: 'Completed registration (1D)',
    completed_registration_7D: 'Completed registration (7D)',
    conv_kf_pf_add_1d: '친구 추가수 (1일)',
    conv_kf_pf_add_1d_rate: '친구 추가율 (1일)',
    conv_kf_pf_add_7d: '친구 추가수 (7일)',
    conv_kf_pf_add_7d_rate: '친구 추가율 (7일)',
    conversionEvent: 'Conversion event',
    conversionEvents: 'Conversion event',
    conversionGoal: 'Conversion goal',
    conversionRate: 'CVR',
    conversionValue: 'Conv. value',
    conversionValues: 'Conv. value',
    conversion_af: 'AF',
    conversion_amazon_reports: 'Amazon',
    conversion_appsFlyer: 'Appsflyer',
    conversion_branch: 'Branch',
    conversion_criteo_reports: 'Criteo',
    conversion_ga: 'GA',
    conversion_ga_cpa: 'GA CPA',
    conversion_googleAnalytics: 'GA',
    conversion_googleAnalytics4: 'GA4',
    conversion_google_reports: 'Google Ads',
    conversion_kakao_pixel: 'Kakao',
    conversion_lead: 'Lead',
    conversion_lead_cpa: 'Lead CPA',
    conversion_linkedin_reports: 'Linkedin',
    conversion_microsoft_reports: 'Microsoft',
    conversion_mobile: 'App',
    conversion_mobile_cpa: 'App CPA',
    conversion_naver_reports: 'Naver',
    conversion_navergfa_reports: 'NaverGFA',
    conversion_pixel: 'Pixel',
    conversion_pixel_cpa: 'Pixel CPA',
    conversion_snapchat_reports: 'Snapchat',
    conversion_tiktok_reports: 'TikTok',
    conversion_twitter_reports: 'Twitter',
    conversion_walmart_reports: 'Walmart',
    conversions: 'Conversions',
    conversionsValue: 'Conv. value',
    costPerMessagingFirstReply: 'Cost per New Messaging Connections',
    costPerMessagingStarted7d: 'Cost per Messaging Conversations Started',
    costPerMsgClick: 'Kakao CPA: All message clicks',
    costPerMsgOpen: 'Kakao CPA: Message opened',
    costPerMsgSend: 'Kakao CPA: Message sent',
    costPerOutboundClick: 'Cost per Outbound Click',
    costPerUniqueOutboundClick: 'Cost per Unique Outbound Click',
    cost_per_conv_kf_pf_add_1d: '친구 추가 수당 비용 (1일)',
    cost_per_conv_kf_pf_add_7d: '친구 추가 수당 비용 (7일)',
    count: 'Count',
    country: 'Country',
    coupon_discount_price: 'Coupon discount price',
    coupon_shipping_fee_amount: 'Coupon shipping fee amount',
    cpa: 'CPA',
    cpa_example: 'CPA: Pixel complete_registration',
    cpa_with_total: 'Total spend',
    cpc: 'CPC',
    cpcFullName: 'Cost per click',
    cpi: 'CPI',
    cpm: 'CPM',
    cpr: 'CPR',
    cpv: 'CPV',
    creativeDescription: 'Facebook creative description',
    creativeImage: 'Facebook creative image',
    creativeTitle: 'Facebook headline',
    creativeWord: 'Ad copy',
    creatives: 'Creatives',
    credits_spent_amount: 'Credits spent amount',
    csv_channel: 'Channel',
    csv_created_at: 'Created At',
    csv_file_id: 'File ID',
    csv_filename: 'Filename',
    csv_id: 'ID',
    csv_updated_at: 'Updated At',
    ctr: 'CTR',
    ctrFullName: 'Click-through rate',
    currency: 'Currency',
    currentFollowCount: 'Current Follow Count',
    cvr: 'CVR',
    dailyBudget: 'Daily budget',
    dailyBudgetAmount: 'Daily Budget',
    dailyBudgetIncludingFees: 'Daily budget w. fees',
    date: 'Date',
    day: 'Daily breakdown',
    device: 'Device',
    deviceTarget: 'Device target',
    disclaimer: '*Affected by iOS 14 updates',
    disclaimer_desc:
      'Conversion data from Facebook campaigns may not be accurate due to the recent iOS 14 updates which allow people to opt-out of tracking.',
    domain: 'Domain',
    downloadData: 'Download',
    duration: 'Duration',
    emojiAnalysis: 'Emoji analysis',
    empty_pixel_custom: 'Pixel: Custom',
    empty_pixel_lead: 'Pixel: Lead',
    empty_pixel_purchase: 'Pixel: Purchase',
    ends: 'Ends',
    engagement: 'Engagement',
    engagements: 'Engagement',
    engine: 'Engine',
    errors: 'Errors',
    fees: 'Fees',
    fetch_reach: 'Fetch reach',
    fetches: 'Fetchs',
    firstImpressionConversions: 'First Impression Conversions',
    firstImpressionValue: 'First Impression Value',
    firstInteractionConversions: 'First Interaction Conversions',
    firstInteractionValue: 'First Interaction Value',
    first_visit_count: 'First Visit Count',
    formLead: 'Form lead',
    frequency: 'Frequency',
    gaRevenue: 'GA: Revenue',
    gaRoas: 'GA: ROAS',
    gender: 'Gender',
    goalCompletions: 'Conversions',
    googleAdGroupAdAsset: 'Google Ad Assets',
    hour: 'Hour',
    hourOfDay: 'Hourly breakdown',
    id: 'ID',
    imageHash: 'Creative image',
    impressionAssistedConversions: 'Impression Assisted Conversions',
    impressionAssistedValue: 'Impressions Assisted Value',
    impressions: 'Impressions',
    install_app: 'App install',
    install_app_1D: 'App install (1D)',
    install_app_7D: 'App install (7D)',
    keyword: 'Keyword',
    keywordName: 'Keyword name',
    keywordText: 'Keyword text',
    keywords: 'Keyword',
    landingUrls: 'Landing URL',
    language: 'Language',
    lastInteractionConversions: 'Last Interaction Conversions',
    lastInteractionValue: 'Last Interaction Value',
    leads: 'Leads',
    level: 'Level',
    lifeTimeBudget: 'Lifetime budget',
    lifeTimeBudgetAmount: 'Lifetime budget',
    likes: 'Likes',
    listeners: 'Listeners',
    listens_frequency: 'Listens frequency',
    location: 'Location',
    market_other_discount_amount: 'Market other discount amount',
    matchingType: 'Match type',
    matchingType_broad: 'Broad match',
    matchingType_exact: 'Exact match',
    matchingType_phrase: 'Phrase match',
    member_email: 'Member email',
    member_id: 'Member ID',
    member_order_amount: 'Member Order Amount',
    member_order_count: 'Member Order Count',
    members_sales: 'Members Sales',
    membership_discount_amount: 'Membership discount amount',
    messagingBlock: 'Blocked Messaging Connections',
    messagingFirstReply: 'New Messaging Connections',
    messagingStarted7d: 'Messaging Conversations Started',
    month: 'Monthly breakdown',
    msgClick: 'Kakao: All message clicks',
    msgOpen: 'Kakao: Message opened',
    msgSend: 'Kakao: Message sent',
    newUser: 'New users',
    newUsers: 'New users',
    newVisits: 'New visits',
    new_list: 'New list',
    new_listener_conversion_rate: 'New listener conversion rate',
    new_listener_streams: 'New listener streams',
    new_listeners: 'New listeners',
    nikeWeekNumber: 'Week number breakdown(W#)',
    nonmember_order_amount: 'Nonmember Order Amount',
    nonmember_order_count: 'Nonmember Order Count',
    numberOfDaysInMonth: 'Number of Days in Current Month',
    numberOfDaysPerRow: 'Number of Days per Row',
    objectives: 'Objective',
    off_spotify_impressions: 'Off spotify impressions',
    order_amount: 'Order Amount',
    order_amount_due: 'Order Amount Due',
    order_amount_per_buyer: 'Order Amount Per Buyer',
    order_amount_per_visitor: 'Order Amount Per Visitor',
    order_buyer_count: 'Order Buyer Count',
    order_cancelled_payment_amount: 'Order Cancelled Payment Amount',
    order_count: 'Order Count',
    order_currency: 'Order Currency',
    order_customer_type: 'Order Customer Type',
    order_date: 'Order Date',
    order_discount_amount: 'Order Discount Amount',
    order_gross_sales: 'Order Gross Sales',
    order_id: 'Order ID',
    order_net_discount: 'Order Net Discount',
    order_net_returns: 'Order Net Returns',
    order_net_sales: 'Order Net Sales',
    order_payment_amount: 'Order Payment Amount',
    order_payment_date: 'Order Payment Date',
    order_payment_method: 'Order Payment Method',
    order_place_name: 'Order place name',
    order_price_amount: 'Order Price Amount',
    order_product_count: 'Order Product Count',
    order_products_cost_amount: 'Order Products Cost Amount',
    order_refund_amount: 'Order Refund Amount',
    order_shipping_fee: 'Order Shipping Fee',
    order_source: 'Order Source',
    order_status: 'Order Status',
    order_tax_amount: 'Order Tax Amount',
    order_total_sales: 'Order Total Sales',
    order_updated_date: 'Order Updated Date',
    os: 'Operating System',
    outboundClicks: 'Outbound Clicks',
    outboundClicksCtr: 'Outbound CTR',
    page: 'Page',
    pageEngagements: 'Page engagement',
    pageLikes: 'Page Likes',
    pagePostCount: 'Page Post Count',
    pageViews: 'Page views',
    page_view: 'Page View',
    pagesViewed: 'Pages viewed',
    pages_view: 'Pages View',
    pageviews: 'Page views',
    paidFollowers: 'Paid followers',
    paidLikes: 'Paid likes',
    paidShares: 'Paid shares',
    paid_listen_reach: 'Paid listen reach',
    paid_listens: 'Paid listens',
    paid_listens_frequency: 'Paid listens frequency',
    participation: 'Participation',
    participation_1D: 'Participation (1D)',
    participation_7D: 'Participation (7D)',
    paying: 'Paying',
    payment_amount: 'Payment amount',
    payment_date: 'Payment date',
    payment_gateway_name: 'Payment gateway name',
    payment_method: 'Payment Method',
    period: 'Past {days} days',
    photoViews: 'Photo views',
    pixelRevenue: 'Revenue',
    pixelRoas: 'ROAS',
    placement: 'Placement',
    placements: 'Placement',
    platform: 'Platform',
    platformPlacement: 'Placement',
    point_incentive_amount: 'Point incentive amount',
    points_spent_amount: 'Points spent amount',
    position: 'Position',
    post: 'Post',
    postAngry: 'Post Angry',
    postCelebrate: 'Post Celebrate',
    postComments: 'Post comments',
    postCurious: 'Post Curious',
    postDislike: 'Post Dislike',
    postEngagement: 'Post Engagement',
    postEngagements: 'Post engagement',
    postHaha: 'Post Haha',
    postId: 'Post ID',
    postImpressions: 'Post Impressions',
    postInsightful: 'Post Insightful',
    postLike: 'Post Like',
    postLink: 'Post Link',
    postLove: 'Post Love',
    postMedia: 'Post Media',
    postReactions: 'Post reactions',
    postSad: 'Post Sad',
    postSave: 'Post Save',
    postSaves: 'Post saves',
    postShares: 'Post shares',
    postSubscribersGained: 'Post Subscribers Gained',
    postSubscribersLost: 'Post Subscribers Lost',
    postSupport: 'Post Support',
    postText: 'Post Text',
    postUnsave: 'Post Unsave',
    postVideoViews: 'Post Video Views',
    postWow: 'Post Wow',
    prduct_name: 'Product name',
    product_code: 'Product Code',
    product_created_date: 'Product Created Date',
    product_currency: 'Product Currency',
    product_detailled_name: 'Product Detailed Name',
    product_id: 'Product ID',
    product_image: 'Product Image',
    product_name: 'Product Name',
    product_name_eng: 'Product name eng',
    product_no: 'Product No',
    product_order_amount: 'Product order amount',
    product_order_price_amount: 'Product Order Price Amount',
    product_order_quantity: 'Product Order Quantity',
    product_price: 'Product Price',
    product_retail_price: 'Product Retail Price',
    product_sku: 'Product Sku',
    product_status: 'Product Status',
    product_updated_date: 'Product Updated Date',
    products_categorydetails: 'Products Categorydetails',
    products_sales: 'Products Sales',
    products_view: 'Products View',
    profileViews: 'Profile Views',
    purchase: 'Purchase',
    purchase_1D: 'Purchase (1D)',
    purchase_7D: 'Purchase (7D)',
    purchase_count: 'Purchase Count',
    purchase_p: 'Purchase price',
    purchase_p_1D: 'Purchase price (1D)',
    purchase_p_7D: 'Purchase price (7D)',
    purchase_rate: 'Purchase Rate',
    purchases: 'Purchases',
    qualityScore: 'Quality Score',
    query: 'Query',
    rawChannelString: 'Blending data channel key',
    re_visit_count: 'Re Visit Count',
    reach: 'Reach',
    region: 'Region',
    remainingDays: 'Remaining Days',
    resultIndicator: 'Result indicator',
    results: 'Results',
    revenue: 'Revenue',
    roas: 'ROAS',
    runLonger: 'Run longer',
    sales_count_per_category: 'Sales Count Per Category',
    sales_item_per_category: 'Sales Item Per Category',
    sales_paymethods: 'Sales Paymethods',
    sales_pervisitors: 'Sales Pervisitors',
    sales_price_per_category: 'Sales Price Per Category',
    sales_times: 'Sales Times',
    searchAppearance: 'Search Appearance',
    searchKeywords: 'Keyword',
    serves: 'Serves',
    sessionDuration: 'Session duration',
    sessions: 'Sessions',
    set_product_discount_amount: 'Set product discount amount',
    shares: 'Shares',
    shipping_fee: 'Shipping fee',
    shipping_fee_discount_amount: 'Shipping fee discount amount',
    sign_up: 'Sign up',
    sign_up_1D: 'Sign up (1D)',
    sign_up_7D: 'Sign up (7D)',
    skips: 'Skips',
    spend: 'Ad spend',
    spendWithMarkup: 'Ad spend(incl. Markup)',
    spendWithVat: 'Ad spend(incl. VAT)',
    starts: 'Starts',
    statistics_header: 'Performance Trends',
    statistics_loading: 'Data loading...',
    status: 'Status',
    streams: 'Streams',
    streams_per_new_listener: 'Streams per new listener',
    streams_per_user: 'Streams per user',
    subChannel: 'Platform',
    subChannels: 'Channel',
    targeting: 'Targeting',
    targetingType: 'Targeting type (Ad set)',
    tax: 'Tax',
    timeSpentPerVisit: 's/visit',
    title_budget: 'Daily budget',
    totalConversionValue: 'Total Conversion Value',
    totalConversions: 'Total Conversions',
    totalCost: 'Total cost',
    totalDurationInDays: 'Total Duration in Days',
    totalEngagement: 'Total engagement',
    totalGAConversions: 'GA: Total conversions',
    totalGoogleAdsConversions: 'Google Ads: Total conversions',
    totalKakaoConversions: 'Kakaotalk: Total conversions',
    totalNaverConversions: 'Naver: Total conversions',
    totalOtherConversions: 'Others: Total conversions',
    totalPixelConversions: 'Pixel: Total conversions',
    totalTiktokConversions: 'Tiktok: Total conversions',
    totalTwitterConversions: 'Twitter: Total conversions',
    total_amount_due: 'Total amount due',
    transactionRevenue: 'Revenue',
    transaction_id: 'Transaction ID',
    uniqueOutboundClicks: 'Unique outbound clicks',
    uniqueOutboundClicksCtr: 'Unique outbound CTR',
    unique_visit_count: 'Unique Visit Count',
    uploadRawData: 'Upload',
    url: 'Url',
    user_count: 'User Count',
    users: 'Users',
    utmCampaign: 'UTM campaign',
    utmContent: 'UTM content',
    utmMedium: 'UTM medium',
    utmSource: 'UTM source',
    utmTerm: 'UTM term',
    video10s: '10s view',
    videoAvgTime: 'Video average play time',
    videoP100: 'Video played to 100% (Views)',
    videoP100Rate: 'Video played to 100% (%)',
    videoP25: 'Video played to 25% (Views)',
    videoP25Rate: 'Video played to 25% (%)',
    videoP50: 'Video played to 50% (Views)',
    videoP50Rate: 'Video played to 50% (%)',
    videoP75: 'Video played to 75% (Views)',
    videoP75Rate: 'Video played to 75% (%)',
    videoThruPlay: 'ThruPlays',
    videoView15sec: '15s video plays',
    videoView2sec: '2s video plays',
    videoView30sec: '30s video plays',
    videoView6sec: '6s video plays',
    videoViewRatio: '10s view rate',
    videoViews: 'Views',
    videoViewsRate: 'View rate',
    video_play_100p: 'Video play 100%',
    video_play_10s: 'Video play 10s',
    video_play_15s: 'Video play 15s',
    video_play_25p: 'Video play 25%',
    video_play_30s: 'Video play 30s',
    video_play_3s: 'Video play 3s',
    video_play_50p: 'Video play 50%',
    video_play_60s: 'Video play 60s',
    video_play_75p: 'Video play 70%',
    viewRate: 'View rate',
    viewThroughConversions: 'Google Ads: View through conversions',
    view_card: 'View card',
    view_card_1D: 'View card (1D)',
    view_card_7D: 'View card (7D)',
    view_cart: 'View cart',
    view_cart_1D: 'View cart (1D)',
    view_cart_7D: 'View cart (7D)',
    views: 'Views',
    visit: 'visits',
    visitDuration: 'Session duration',
    visitDurationWithoutBounce: 'Bounce rate',
    visit_count: 'Visit Count',
    visit_rate: 'Visit Rate',
    visitors_dailyactive: 'Visitors Dailyactive',
    visitors_pageview: 'Visitors Pageview',
    visitors_unique: 'Visitors Unique',
    visitors_view: 'Visitors View',
    visitpaths_adkeywordsales: 'Visitpaths Adkeywordsales',
    visitpaths_ads: 'Visitpaths Ads',
    visitpaths_adsales: 'Visitpaths Adsales',
    visitpaths_domains: 'Visitpaths Domains',
    visitpaths_domainsales: 'Visitpaths Domainsales',
    visitpaths_keyworddetails: 'Visitpaths Keyworddetails',
    visitpaths_keywords: 'Visitpaths Keywords',
    visitpaths_keywordsales: 'Visitpaths Keywordsales',
    visitpaths_urls: 'Visitpaths Urls',
    visits: 'visits',
    week: 'Weekly breakdown(Start: Mon)',
    weekDate: 'Week date breakdown',
    weekSunSat: 'Weekly breakdown(Start: Sun)',
  },
  ko: {
    Device: '디바이스',
    VideoView3sec: '3초 이상 재생',
    ad: '광고 소재',
    adAccount: '광고 계정',
    adAccountName: '광고 계정',
    adId: '광고 ID',
    adName: '광고 이름',
    adSet: '광고 세트',
    adSetId: '광고 세트 ID',
    adSetName: '광고 세트 이름',
    adSetStatus: '광고 세트 상태',
    adSettings: '광고 설정 보기',
    adSpent: '광고 비용',
    adStatus: '광고 상태',
    addBudget: '일일 예산 추가',
    add_cart_count: '담긴수',
    add_cart_rate: '담김율',
    add_to_cart: '장바구니 추가',
    add_to_cart_1D: '장바구니 추가 (1일)',
    add_to_cart_7D: '장바구니 추가 (7일)',
    adeffect_ad_details: '광고효과 분석',
    adeffect_addetails: '광고효과 분석',
    age: '연령대',
    all: '없음',
    allConversions: '총 전환수(구글)',
    amountSpentPercentage: '지출 금액 비율',
    appPlatforms: '앱 기기',
    app_discount_amount: '앱 할인금액',
    app_install: '앱설치',
    app_install_1D: '앱설치 (1일)',
    app_install_7D: '앱설치 (7일)',
    assistedConversions: '지원 전환',
    assistedValue: '지원 가치',
    autoTime: '자동 기간 설정 데이터',
    averageSessionDuration: '접속 시간',
    bidCap: '입찰 한도',
    bidStrategies: '입찰 전략',
    bidStrategy: '입찰 전략',
    billingHistory: '결제 내역',
    billing_name: '결제자명',
    bounceRate: '이탈률',
    bouncedUsers: '이탈 사용자',
    bounces: '이탈수',
    budget: '예산',
    buyers_count: '구매자수',
    campaign: '캠페인',
    campaignId: '캠페인 ID',
    campaignName: '캠페인 이름',
    campaignStatus: '캠페인 상태',
    carts_action: '장바구니 분석',
    carts_count_per_category: '카테고리별 담긴수',
    category_name: '카테고리명',
    category_no: '카테고리번호',
    channel: '채널',
    channelAdAccountId: '광고 계정 ID',
    channelKeywordId: '키워드 ID',
    channelSubType: '채널 타입',
    channelSubType_app_campaign: '앱',
    channelSubType_app_campaign_for_engagement: '참여 유도 앱',
    channelSubType_app_campaign_for_pre_registration: '사전 등록 유도 앱',
    channelSubType_brand_search: '브랜드 검색',
    channelSubType_daum_shopping: '다음 쇼핑',
    channelSubType_display: '디스플레이',
    channelSubType_display_express: '이미지',
    channelSubType_display_gmail_ad: '지메일 이미지',
    channelSubType_display_mobile_app: '모바일 이미지',
    channelSubType_display_smart_campaign: '스마트 이미지',
    channelSubType_local_campaign: '지역',
    channelSubType_place: '플레이스',
    channelSubType_search: '검색',
    channelSubType_search_express: '검색',
    channelSubType_search_mobile_app: '모바일 검색',
    channelSubType_shopping: '쇼핑',
    channelSubType_shopping_comparison_listing_ads: '비교 쇼핑',
    channelSubType_shopping_smart_ads: '스마트 쇼핑',
    channelSubType_smart_campaign: '스마트',
    channelSubType_sponsored_board: '스폰서 보드',
    channelSubType_talk_biz_board: '비즈보드',
    channelSubType_talk_channel: '채널톡',
    channelSubType_unknown: '알수없음',
    channelSubType_unspecified: '기타',
    channelSubType_video: '비디오',
    channelSubType_video_action: '액션 영상',
    channelSubType_video_non_skippable: '건너뛸 수 있는 영상',
    channelSubType_video_outstream: '아웃스트림 영상',
    channelSubType_video_sequence: '동영상 광고 시퀀스',
    channelSubType_web_site: '웹사이트',
    clicks: '링크 클릭',
    clicksAll: '클릭 (전체)',
    clicksLead: '링크드인 잠재고객',
    colorClustering: '컬러 클러스터링',
    comments: '페이지 댓글',
    completed_registration: '가입완료',
    completed_registration_1D: '가입완료 (1일)',
    completed_registration_7D: '가입완료 (7일)',
    conv_kf_pf_add_1d: '친구 추가수 (1일)',
    conv_kf_pf_add_1d_rate: '친구 추가율 (1일)',
    conv_kf_pf_add_7d: '친구 추가수 (7일)',
    conv_kf_pf_add_7d_rate: '친구 추가율 (7일)',
    conversionEvent: '전환 이벤트',
    conversionEvents: '전환 이벤트',
    conversionGoal: '전환 목표',
    conversionRate: '전환율',
    conversionValue: '전환값',
    conversionValues: '전환값',
    conversion_af: 'AF',
    conversion_amazon_reports: 'Amazon',
    conversion_appsFlyer: '앱스플라이어',
    conversion_branch: 'Branch',
    conversion_criteo_reports: '크리테오',
    conversion_ga: 'GA',
    conversion_ga_cpa: 'GA CPA',
    conversion_googleAnalytics: 'GA',
    conversion_googleAnalytics4: 'GA4',
    conversion_google_reports: 'Google Ads',
    conversion_kakao_pixel: 'Kakao',
    conversion_lead: 'Lead',
    conversion_lead_cpa: 'Lead CPA',
    conversion_linkedin_reports: 'Linkedin',
    conversion_microsoft_reports: 'Microsoft',
    conversion_mobile: '앱',
    conversion_mobile_cpa: '앱 CPA',
    conversion_naver_reports: 'Naver',
    conversion_navergfa_reports: 'NaverGFA',
    conversion_pixel: '픽셀',
    conversion_pixel_cpa: '픽셀 CPA',
    conversion_snapchat_reports: 'Snapchat',
    conversion_tiktok_reports: 'Tiktok',
    conversion_twitter_reports: 'Twitter',
    conversion_walmart_reports: 'Walmart',
    conversions: '총 전환수',
    conversionsValue: '전환값',
    costPerMessagingFirstReply: '신규 메시지 대화당 비용',
    costPerMessagingStarted7d: '메시지 대화 시작당 비용',
    costPerMsgClick: '카카오 CPA: 전체 클릭수',
    costPerMsgOpen: '카카오 CPA: 열람수',
    costPerMsgSend: '카카오 CPA: 발송수',
    costPerOutboundClick: '아웃바운드 클릭당 비용',
    costPerUniqueOutboundClick: '고유 아웃바운드 클릭당 비용',
    cost_per_conv_kf_pf_add_1d: '친구 추가 수당 비용 (1일)',
    cost_per_conv_kf_pf_add_7d: '친구 추가 수당 비용 (7일)',
    count: '조회수',
    country: '나라',
    coupon_discount_price: '쿠폰 할인금액',
    coupon_shipping_fee_amount: '배송비 쿠폰금액',
    cpa: '전환당 비용',
    cpa_example: 'CPA: Pixel complete_registration',
    cpa_with_total: '전체 비용',
    cpc: 'CPC',
    cpcFullName: '클릭당 비용',
    cpi: 'CPI',
    cpm: 'CPM',
    cpr: '결과당 비용',
    cpv: 'CPV',
    creativeDescription: '페이스북 광고 설명',
    creativeImage: '페이스북 광고 이미지',
    creativeTitle: '페이스북 광고 제목',
    creativeWord: '광고 문구',
    creatives: '광고 소재',
    credits_spent_amount: '예치금 소진금액',
    csv_channel: 'Channel',
    csv_created_at: 'Created At',
    csv_file_id: 'File ID',
    csv_filename: 'Filename',
    csv_id: 'ID',
    csv_updated_at: 'Updated At',
    ctr: 'CTR',
    ctrFullName: '클릭률',
    currency: '통화',
    currentFollowCount: '팔로워 수',
    cvr: 'CVR',
    dailyBudget: '일 예산',
    dailyBudgetAmount: '일 예산',
    dailyBudgetIncludingFees: '수수료 포함 일 예산',
    date: '날짜',
    day: '일별 데이터',
    device: '디바이스',
    deviceTarget: '노출 기기',
    disclaimer: '*iOS 14 업데이트 영향 있음',
    disclaimer_desc:
      'iOS 14 업데이트 후 광고 데이터 수집을 거부한 사용자들에 의해 페이스북 전환 데이터가 정확하지 않을 수 있습니다.',
    domain: '도메인',
    downloadData: '다운로드',
    duration: '길이',
    emojiAnalysis: '이모티콘 분석',
    empty_pixel_custom: 'pixel: custom',
    empty_pixel_lead: 'pixel: lead',
    empty_pixel_purchase: 'pixel: purchase',
    ends: '종료일',
    engagement: '참여',
    engagements: '참여',
    engine: '검색엔진',
    errors: '오류',
    fees: '수수료',
    fetch_reach: '광고호출 도달',
    fetches: '광고호출',
    firstImpressionConversions: '첫 번째 노출 전환수',
    firstImpressionValue: '첫 번째 노출 가치',
    firstInteractionConversions: '첫 번째 상호작용 전환',
    firstInteractionValue: '첫 번째 상호작용 가치',
    first_visit_count: '처음방문자수',
    formLead: '잠재고객',
    frequency: '빈도',
    gaRevenue: 'GA: 매출',
    gaRoas: 'GA: ROAS',
    gender: '성별',
    goalCompletions: '전환',
    googleAdGroupAdAsset: '구글 광고 확장 소재',
    hour: '시간',
    hourOfDay: '시간대별 데이터',
    id: 'ID',
    imageHash: '광고 이미지 그룹',
    impressionAssistedConversions: '노출 지원전환 전환',
    impressionAssistedValue: '노출 지원전환 가치',
    impressions: '노출',
    install_app: '앱설치',
    install_app_1D: '앱설치 (1일)',
    install_app_7D: '앱설치 (7일)',
    keyword: '키워드',
    keywordName: '키워드 이름',
    keywordText: '키워드 통합',
    keywords: '키워드',
    landingUrls: '랜딩 URL',
    language: '언어',
    lastInteractionConversions: '마지막 상호작용 전환',
    lastInteractionValue: '마지막 상호작용 가치',
    leads: '고객 DB',
    level: '레벨',
    lifeTimeBudget: '전체예산',
    lifeTimeBudgetAmount: '전체예산',
    likes: '페이지 추천',
    listeners: '이용자',
    listens_frequency: '재생 빈도',
    location: '위치',
    market_other_discount_amount: '마켓 할인금액',
    matchingType: '검색 유형',
    matchingType_broad: '확장 검색',
    matchingType_exact: '일치 검색',
    matchingType_phrase: '구문 검색',
    member_email: '회원 이메일',
    member_id: '회원 아이디',
    member_order_amount: '회원 매출액',
    member_order_count: '회원 구매건수',
    members_sales: '유저별 매출',
    membership_discount_amount: '멤버쉽 할인금액',
    messagingBlock: '차단된 메시지 상대',
    messagingFirstReply: '새로 추가된 메시지 상대',
    messagingStarted7d: '메시지 대화 시작',
    month: '월별 데이터',
    msgClick: '카카오: 전체 클릭수',
    msgOpen: '카카오: 열람수',
    msgSend: '카카오: 발송수',
    newUser: '신규 방문자',
    newUsers: '신규 방문자',
    newVisits: '신규 방문자',
    new_list: '신규 리스트',
    new_listener_conversion_rate: '신규 청취 전환율',
    new_listener_streams: '신규 이용자 스트림',
    new_listeners: '신규 이용자',
    nikeWeekNumber: '주차별 데이터(W#)',
    nonmember_order_amount: '비회원 매출액',
    nonmember_order_count: '비회원 구매건수',
    numberOfDaysInMonth: '이번 달 일수',
    numberOfDaysPerRow: '행 기간 일수',
    objectives: '목표',
    off_spotify_impressions: '스포티파이 외부 노출',
    order_amount: '매출액',
    order_amount_due: '주문 청구/예정액',
    order_amount_per_buyer: '구매당 매출',
    order_amount_per_visitor: '방문당 매출',
    order_buyer_count: '구매자 수',
    order_cancelled_payment_amount: '주문 취소액',
    order_count: '구매 건수',
    order_currency: '주문 통화',
    order_customer_type: '고객 유형',
    order_date: '주문 날짜',
    order_discount_amount: '주문 총할인액',
    order_gross_sales: '주문 총매출',
    order_id: '주문 번호',
    order_net_discount: '주문 순할인액',
    order_net_returns: '주문 순수익',
    order_net_sales: '주문 순판매액',
    order_payment_amount: '주문 결제액',
    order_payment_date: '주문 결제일',
    order_payment_method: '결제수단',
    order_place_name: '주문 경로',
    order_price_amount: '주문 상품 총액',
    order_product_count: '판매물품수',
    order_products_cost_amount: '주문 상품 원가 금액',
    order_refund_amount: '주문 환불 총액',
    order_shipping_fee: '주문 배송비',
    order_source: '주문 경로',
    order_status: '주문 현황',
    order_tax_amount: '주문 세금총액',
    order_total_sales: '주문 총판매액',
    order_updated_date: '주문 최종수정일',
    os: '운영 체제',
    outboundClicks: '아웃바운드 클릭수',
    outboundClicksCtr: '아웃바운드 클릭률',
    page: '페이지',
    pageEngagements: '페이지 참여',
    pageLikes: '페이지 좋아요',
    pagePostCount: '게시물 수',
    pageViews: '페이지 뷰',
    page_view: '페이지뷰',
    pagesViewed: '조회된 페이지',
    pages_view: '페이지 분석',
    pageviews: '페이지 뷰',
    paidFollowers: 'Paid followers',
    paidLikes: 'Paid likes',
    paidShares: 'Paid shares',
    paid_listen_reach: '유료 이용자 도달',
    paid_listens: '유료_이용자',
    paid_listens_frequency: '유료(광고) 재생 빈도',
    participation: '잠재고객',
    participation_1D: '잠재고객 (1일)',
    participation_7D: '잠재고객 (7일)',
    paying: '유료고객',
    payment_amount: '최종 결제금액',
    payment_date: '결제 날짜',
    payment_gateway_name: 'PG앱 이름',
    payment_method: '결제수단',
    period: '지난 {days} 일',
    photoViews: '사진 조회',
    pixelRevenue: '구매값',
    pixelRoas: 'ROAS',
    placement: '노출 위치',
    placements: '노출 위치',
    platform: '플랫폼',
    platformPlacement: '노출 위치',
    point_incentive_amount: '적립금',
    points_spent_amount: '적립금 소진금액',
    position: '게재순위',
    post: '게시물',
    postAngry: '게시물 반응- 화나요',
    postCelebrate: '게시물 반응 - 축하',
    postComments: '게시물 댓글',
    postCurious: '게시물 반응 - 궁금',
    postDislike: '게시물 싫어요',
    postEngagement: '게시물 참여',
    postEngagements: '게시물 참여',
    postHaha: '게시물 반응- 하하',
    postId: '게시물 ID',
    postImpressions: '게시물 노출수',
    postInsightful: '게시물 반응 - 통찰력',
    postLike: '게시물 좋아요',
    postLink: '게시물 링크',
    postLove: '게시물 반응 - 마음에 쏙듬',
    postMedia: '게시물 미디어',
    postReactions: '게시물 공감',
    postSad: '게시물 반응- 슬퍼요',
    postSave: '게시물 저장',
    postSaves: '게시물 저장',
    postShares: '게시물 공유',
    postSubscribersGained: '게시물 기반 구독수',
    postSubscribersLost: '게시물 기반 구독 취소수',
    postSupport: '게시물 반응 - 응원',
    postText: '게시물 텍스트',
    postUnsave: '게시물 저장 취소',
    postVideoViews: '게시물 조회수',
    postWow: '게시물 반응- 와우',
    prduct_name: '상품 이름',
    product_code: '상품코드',
    product_created_date: '상품 등록일',
    product_currency: '상품 통화',
    product_detailled_name: '상품 상세명',
    product_id: '상품 번호',
    product_image: '상품 이미지',
    product_name: '상품명',
    product_name_eng: '영문 상품 이름',
    product_no: '상품번호',
    product_order_amount: '주문 금액',
    product_order_price_amount: '주문 총액',
    product_order_quantity: '주문 수량',
    product_price: '상품 판매가',
    product_retail_price: '상품 소비자가',
    product_sku: '상품 고유번호',
    product_status: '상품 판매상태',
    product_updated_date: '상품 최종수정일',
    products_categorydetails: '상품군별 분석',
    products_sales: '상품 정보',
    products_view: '상품 조회수',
    profileViews: '프로필 조회수',
    purchase: '구매',
    purchase_1D: '구매 (1일)',
    purchase_7D: '구매 (7일)',
    purchase_count: '구매건수',
    purchase_p: '구매금액',
    purchase_p_1D: '구매금액 (1일)',
    purchase_p_7D: '구매금액 (7일)',
    purchase_rate: '구매율',
    purchases: '구매하기',
    qualityScore: '품질평가점수',
    query: '쿼리',
    rawChannelString: '데이터 혼합 채널 지표',
    re_visit_count: '재방문자 수',
    reach: '도달',
    region: '지역',
    remainingDays: '남은 일수',
    resultIndicator: '결과 지표',
    results: '결과',
    revenue: '매출',
    roas: 'ROAS',
    runLonger: '광고 기간 연장',
    sales_count_per_category: '카테고리별 판매건수',
    sales_item_per_category: '카테고리별 판매물품수',
    sales_paymethods: '상품 결제수단',
    sales_pervisitors: '고객당 매출액',
    sales_price_per_category: '카테고리별 상품판매금액',
    sales_times: '주문 시간',
    searchAppearance: '검색 노출',
    searchKeywords: '키워드',
    serves: '광고총계',
    sessionDuration: '접속 시간',
    sessions: '세션 수',
    set_product_discount_amount: '세트 상품 할인금액',
    shares: '페이지 공유',
    shipping_fee: '배송비',
    shipping_fee_discount_amount: '배송비 할인금액',
    sign_up: '서비스신청',
    sign_up_1D: '서비스신청 (1일)',
    sign_up_7D: '서비스신청 (7일)',
    skips: '건너뛰기',
    spend: '광고 비용',
    spendWithMarkup: '광고 비용(Markup 포함)',
    spendWithVat: '광고 비용(VAT 포함)',
    starts: '시작일',
    statistics_header: '성과 추세',
    statistics_loading: '로딩중...',
    status: '상태',
    streams: '스트림',
    streams_per_new_listener: '신규 청취자별 스트리밍 횟수',
    streams_per_user: '청취자별 스트리밍 횟수',
    subChannel: '플랫폼',
    subChannels: '채널',
    targeting: '타겟',
    targetingType: '타게팅 종류',
    tax: '세금',
    timeSpentPerVisit: '초',
    title_budget: '일 예산',
    totalConversionValue: '총 전환 가치',
    totalConversions: '총 전환수',
    totalCost: '총 비용',
    totalDurationInDays: '총 일수',
    totalEngagement: '총 참여수',
    totalGAConversions: 'GA: 총 전환수',
    totalGoogleAdsConversions: 'Google Ads: 총 전환수',
    totalKakaoConversions: '카카오톡: 총 전환수',
    totalNaverConversions: '네이버: 총 전환수',
    totalOtherConversions: '기타: 총 전환수',
    totalPixelConversions: '픽셀: 총 전환수',
    totalTiktokConversions: 'Tiktok: 총 전환수',
    totalTwitterConversions: '트위터: 총 전환수',
    total_amount_due: '결제 예정금액',
    transactionRevenue: '매출',
    transaction_id: '카드 거래 아이디',
    uniqueOutboundClicks: '고유 아웃바운드 클릭수',
    uniqueOutboundClicksCtr: '고유 아웃바운드 CTR',
    unique_visit_count: '순방문자 수',
    uploadRawData: '업로드',
    url: 'URL',
    user_count: '사용자수',
    users: '사용자',
    utmCampaign: 'UTM campaign',
    utmContent: 'UTM content',
    utmMedium: 'UTM medium',
    utmSource: 'UTM source',
    utmTerm: 'UTM term',
    video10s: '10초 이상 시청수',
    videoAvgTime: '동영상 평균 재생 시간',
    videoP100: '동영상 100% 재생 (조회수)',
    videoP100Rate: '동영상 100% 재생 (%)',
    videoP25: '동영상 25% 재생 (조회수)',
    videoP25Rate: '동영상 25% 재생 (%)',
    videoP50: '동영상 50% 재생 (조회수)',
    videoP50Rate: '동영상 50% 재생 (%)',
    videoP75: '동영상 75% 재생 (조회수)',
    videoP75Rate: '동영상 75% 재생 (%)',
    videoThruPlay: '전부 또는 15초 이상 재생',
    videoView15sec: '15초 이상 재생',
    videoView2sec: '2초 이상 재생',
    videoView30sec: '30초 이상 재생',
    videoView6sec: '6초 이상 재생',
    videoViewRatio: '10초 이상 시청률',
    videoViews: '조회수',
    videoViewsRate: '조회율',
    video_play_100p: '100% 재생수',
    video_play_10s: '10초 재생수',
    video_play_15s: '15초 재생수',
    video_play_25p: '25% 재생수',
    video_play_30s: '30초 재생수',
    video_play_3s: '3초 재생수',
    video_play_50p: '50% 재생수',
    video_play_60s: '60초 재생수',
    video_play_75p: '75% 재생수',
    viewRate: '조회율',
    viewThroughConversions: 'Google Ads: 조회 후 전환',
    view_card: '카드 보기',
    view_card_1D: '카드 보기 (1일)',
    view_card_7D: '카드 보기 (7일)',
    view_cart: '장바구니 보기',
    view_cart_1D: '장바구니 보기 (1일)',
    view_cart_7D: '장바구니 보기 (7일)',
    views: '조회수',
    visit: '방문 수',
    visitDuration: '접속 시간',
    visitDurationWithoutBounce: '이탈률',
    visit_count: '방문수',
    visit_rate: '방문비율',
    visitors_dailyactive: '일별 사용자',
    visitors_pageview: '일별 페이지뷰',
    visitors_unique: '순수 방문자',
    visitors_view: '방문자 분석',
    visitpaths_adkeywordsales: '검색어/광고매체별 유입',
    visitpaths_ads: '유입별 광고정보',
    visitpaths_adsales: '광고매체별 매출',
    visitpaths_domains: '도메인별 유입',
    visitpaths_domainsales: '도메인별 매출',
    visitpaths_keyworddetails: '검색어(상세)별 유입',
    visitpaths_keywords: '검색어(일반)별 유입',
    visitpaths_keywordsales: '검색어별 매출',
    visitpaths_urls: 'URL별 유입',
    visits: '방문 수',
    week: '주별 데이터(시작: 월)',
    weekDate: '요일 데이터',
    weekSunSat: '주별 데이터(시작: 일)',
  },
};
